"use client";

import { useEffect, useRef, useState } from "react";

const DEFAULT_HINT_TIMEOUT_MS = 2500;

export const useBlockOneFingerTouch = <T extends HTMLElement>(
  maxWidth: number,
  hintTimeoutMs = DEFAULT_HINT_TIMEOUT_MS,
) => {
  const ref = useRef<T>(null);
  const [didBlock, setDidBlock] = useState(false);

  useEffect(() => {
    const node = ref.current;
    let hintTimer: ReturnType<typeof setTimeout> | undefined;

    const blockOneFingerTouch = (event: TouchEvent) => {
      if (window.innerWidth >= maxWidth) return;
      if (event.touches.length === 1) {
        event.stopImmediatePropagation();
        setDidBlock(true);
        clearTimeout(hintTimer);
        hintTimer = setTimeout(() => setDidBlock(false), hintTimeoutMs);
      } else if (event.touches.length >= 2) {
        clearTimeout(hintTimer);
        setDidBlock(false);
      }
    };

    node?.addEventListener("touchstart", blockOneFingerTouch, { capture: true, passive: true });
    node?.addEventListener("touchmove", blockOneFingerTouch, { capture: true, passive: true });

    return () => {
      clearTimeout(hintTimer);
      node?.removeEventListener("touchstart", blockOneFingerTouch, { capture: true });
      node?.removeEventListener("touchmove", blockOneFingerTouch, { capture: true });
    };
  }, [maxWidth, hintTimeoutMs]);

  return { ref, didBlock };
};
